import wcmatch from 'wildcard-match';

import { LOCAL_DOMAINS } from '../../../../../shared/partners.js';

export const createVerifyOrigin = ({
  domains = [],
  embeddedMode,
}: {
  domains?: string[];
  embeddedMode: boolean;
}) => {
  const allowedOrigins = embeddedMode ? domains : [__STANDALONE_URL__]; // Blinks use Web3 RPC in Standalone mode.

  const allowedOriginMatchers =
    [
      ...LOCAL_DOMAINS, // Allow localhost by default.
      ...allowedOrigins,
    ].flatMap((pattern) => {
      // If a protocol is missed, it means it allows both 'http' and 'https'.
      if (!pattern.startsWith('http')) {
        return [wcmatch(`http://${pattern}`), wcmatch(`https://${pattern}`)];
      }
      return wcmatch(pattern);
    }) ?? [];

  return function verifyOrigin(origin: string) {
    return allowedOriginMatchers.some((isMatch) => isMatch(origin));
  };
};
